import { render } from "./AnalyticsDashboard.vue?vue&type=template&id=52338906&scoped=true"
import script from "./AnalyticsDashboard.vue?vue&type=script&lang=js"
export * from "./AnalyticsDashboard.vue?vue&type=script&lang=js"

import "./AnalyticsDashboard.vue?vue&type=style&index=0&id=52338906&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52338906"]])

export default __exports__